import { render, staticRenderFns } from "./BoardList.vue?vue&type=template&id=e2c99858&scoped=true"
import script from "./BoardList.ts?vue&type=script&lang=ts&external"
export * from "./BoardList.ts?vue&type=script&lang=ts&external"
import style0 from "./BoardList.vue?vue&type=style&index=0&id=e2c99858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c99858",
  null
  
)

export default component.exports